import { render, staticRenderFns } from "./StorageTabs.vue?vue&type=template&id=25c8dcc4&lang=pug&"
import script from "./StorageTabs.vue?vue&type=script&lang=js&"
export * from "./StorageTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports